const MAX_LENGTH_COMPANY_NAME = 70;
const MAX_LENGTH_PRODUCT_NAME = 24;

export {
  MAX_LENGTH_COMPANY_NAME,
  MAX_LENGTH_PRODUCT_NAME
}
